import React, { useEffect } from 'react';
import { object, func, string, bool, node, number, array } from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { Container, FastFilters, FastFilterItem, FilterLink, LabelHeader, FilterText } from './fast-filter.styles';
import { Image, Heading } from '../../atoms';
import { Carousel } from '../../molecules';

function FastFilter({
  filters = {},
  onItemClick,
  onView,
  desktopMode,
  itemHeight,
  slidesPerView
}) {
  const {
    attributeFilters
  } = filters;
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0,
    delay: 1000
  });
  useEffect(() => {
    if (inView) {
      onView({
        filters
      });
    }
  }, [inView]);

  const RenderVariations = ({
    children,
    filter
  }) => {
    if (desktopMode && filter.values.length > slidesPerView) {
      return /*#__PURE__*/React.createElement(Carousel, {
        auto: false,
        showControls: false,
        showArrowControls: true,
        showPartial: false,
        showPartialNextSlide: false,
        gutter: 0,
        slidesPerView: slidesPerView,
        "data-testid": "carousel"
      }, children);
    }

    return /*#__PURE__*/React.createElement(FastFilters, {
      "data-testid": "m-carousel",
      desktopMode: desktopMode,
      gap: desktopMode ? 12 : 2
    }, children);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, attributeFilters.map((filter, idx) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelHeader, null, /*#__PURE__*/React.createElement(Heading, {
    "data-testid": "header-label",
    as: "h2",
    fontSize: desktopMode ? 18 : 14,
    color: "text.attributeLabel"
  }, filter.label)), /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    "data-testid": "filter-item-container",
    key: idx,
    desktopMode: desktopMode
  }, /*#__PURE__*/React.createElement(RenderVariations, {
    filter: filter
  }, filter == null ? void 0 : filter.values.map(item => /*#__PURE__*/React.createElement(FilterLink, {
    key: item.id,
    role: "button",
    onClick: e => onItemClick(e, item),
    href: item.url || item.href,
    "data-testid": "filter-item-link"
  }, /*#__PURE__*/React.createElement(FastFilterItem, {
    "data-testid": "filter-item-label",
    height: itemHeight,
    desktopMode: desktopMode
  }, item.filterType === 'icon' ? /*#__PURE__*/React.createElement(Image, {
    alt: item.label,
    title: item.label,
    "data-testid": "filter-item-image",
    src: item.icon
  }) : /*#__PURE__*/React.createElement(FilterText, {
    px: 2,
    desktopMode: desktopMode,
    "data-testid": "filter-item-text"
  }, item.label)))))))));
}

process.env.NODE_ENV !== "production" ? FastFilter.propTypes = {
  filters: object,
  onItemClick: func,
  onView: func,
  label: string,
  desktopMode: bool,
  itemHeight: number,
  itemWidth: number,
  children: node,
  filter: array,
  slidesPerView: number
} : void 0;
FastFilter.defaultProps = {
  filters: {},
  onItemClick: () => {},
  onView: () => {},
  slidesPerView: 5
};
export default FastFilter;